import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { Label } from 'ng2-charts';
import { Color } from 'chartjs-plugin-datalabels/types/options';

@Component({
    selector: 'app-statistics-chart',
    templateUrl: './statistics-chart.component.html',
    styleUrls: ['./statistics-chart.component.scss']
})
export class StatisticsChartComponent implements OnInit {
    public barChartOptions: ChartOptions = {
        responsive: true,
        // We use these empty structures as placeholders for dynamic theming.
        scales: {
            xAxes: [
                {
                    gridLines: {
                        display: true,
                        drawBorder: true,
                        color: 'white',
                        zeroLineColor: '#E8EAED'
                    },
                    ticks: {
                        padding: 0,
                        fontSize: 14,
                        fontFamily: '"Montserrat", sans-serif'
                    }
                }
            ],
            yAxes: [
                {
                    gridLines: {
                        display: false,
                        drawBorder: true,
                        zeroLineColor: '#E8EAED'
                    },
                    ticks: {
                        padding: 0,
                        fontSize: 14,
                        fontFamily: '"Montserrat", sans-serif'
                    }
                }
            ]
        },
        plugins: {
            datalabels: {
                anchor: 'end',
                align: 'end'
            }
        },
        tooltips: {
            borderColor: 'white',
            borderWidth: 0
        }
    };
    @Input() public barChartLabels: Label[] = [];
    @Input() public data: any[] = [];
    public barChartType: ChartType = 'bar';
    public barChartLegend = false;
    public barChartPlugins = [pluginDataLabels];

    public barChartData: ChartDataSets[] = [
        // { data: [65, 59, 80, 81, 56, 55, 40], label: "Series A" },
        {
            data: [],
            label: 'Plays Nbr',
            backgroundColor: [
                '#2F3541',
                '#2F3541',
                '#2F3541',
                '#2F3541',
                '#2F3541',
                '#2F3541',
                '#2F3541'
            ],
            hoverBackgroundColor: '#fde150',
            barPercentage: 0.5,
            barThickness: 7,
            maxBarThickness: 8,
            minBarLength: 2
        }
    ];

    constructor() {}

    ngOnInit(): void {
        this.barChartData[0].data = this.data;
    }

    // events
    public chartClicked({ event, active }: { event: MouseEvent; active: {}[] }): void {}

    public chartHovered({ event, active }: { event: MouseEvent; active: {}[] }): void {}

    public randomize(): void {
        // Only Change 3 values
        const data = [
            Math.round(Math.random() * 100),
            59,
            80,
            Math.random() * 100,
            56,
            Math.random() * 100,
            40
        ];
        this.barChartData[0].data = data;
    }
}
